import styled from 'styled-components/macro';

const ErrorMessage = styled.div`
  display: flex;
  padding-top: ${props => props.theme.spacing.xs2};
  font-size: ${props => props.theme.sizes.xs};
  color: ${props => props.theme.colors.danger};
`;

export default ErrorMessage;
